export const bigrams: Record<string, Record<string, number>> = {
  A: {
    AT: 18317,
    RA: 13999,
    AL: 13873,
    AN: 13554,
    AR: 12030,
    LA: 10282,
    TA: 8059,
    AS: 8029,
    CA: 7624,
    MA: 6973,
    EA: 6561,
    NA: 6367,
    AC: 6328,
    IA: 5664,
    HA: 4913,
    PA: 4717,
    AM: 4620,
    AB: 4455,
    AD: 4153,
    AP: 3856,
    GA: 3849,
    AG: 3578,
    SA: 3517,
    BA: 3481,
    AI: 3209,
    FA: 2620,
    DA: 2506,
    WA: 2340,
    VA: 2286,
    AU: 1852,
    UA: 1818,
    OA: 1615,
    AV: 1554,
    AY: 1330,
    AK: 1277,
    AW: 924,
    AF: 901,
    ZA: 864,
    AE: 816,
    KA: 743,
    AZ: 632,
    YA: 544,
    JA: 537,
    AX: 458,
    AH: 453,
    XA: 399,
  },
  B: {
    BL: 4607,
    AB: 4455,
    BA: 3481,
    BE: 3400,
    BI: 3349,
    BO: 3344,
    BR: 2392,
    MB: 2246,
    BU: 1979,
    UB: 1969,
    BB: 1840,
    IB: 1800,
    OB: 1793,
    EB: 1382,
    RB: 1349,
    BS: 754,
    NB: 457,
    TB: 372,
    SB: 322,
    LB: 287,
    YB: 240,
    DB: 237,
    BY: 213,
  },
  C: {
    IC: 11478,
    CO: 8470,
    CA: 7624,
    CH: 6859,
    AC: 6328,
    EC: 5763,
    CE: 5726,
    NC: 5521,
    CI: 4851,
    CT: 4426,
    SC: 4042,
    CK: 3952,
    OC: 3593,
    CR: 3184,
    CU: 2977,
    CL: 2269,
    UC: 2078,
    RC: 1993,
    CC: 1798,
    TC: 1065,
    CY: 904,
    CS: 779,
    YC: 723,
    XC: 446,
    LC: 433,
  },
  D: {
    ED: 17538,
    DE: 10664,
    DI: 9448,
    ND: 6332,
    ID: 4615,
    AD: 4153,
    DO: 3749,
    DS: 2825,
    OD: 2744,
    DA: 2506,
    RD: 2425,
    DR: 2266,
    DD: 2004,
    DU: 1808,
    UD: 1374,
    DL: 1299,
    LD: 1169,
    DG: 617,
    DY: 576,
    DN: 460,
    YD: 403,
    DW: 274,
    DB: 237,
    DM: 210,
  },
  E: {
    ES: 35462,
    ER: 30628,
    TE: 19548,
    RE: 19205,
    ED: 17538,
    EN: 16909,
    LE: 14713,
    NE: 13210,
    SE: 11672,
    DE: 10664,
    IE: 9723,
    ME: 8158,
    EL: 8044,
    HE: 7868,
    EE: 7786,
    ET: 7760,
    VE: 7483,
    PE: 7177,
    EA: 6561,
    GE: 6042,
    EC: 5763,
    CE: 5726,
    EM: 5560,
    EP: 3910,
    KE: 3747,
    EX: 3551,
    ZE: 3486,
    BE: 3400,
    FE: 3029,
    EG: 1906,
    EV: 1901,
    EF: 1845,
    WE: 1837,
    EI: 1707,
    EO: 1706,
    UE: 1581,
    EU: 1394,
    EB: 1382,
    EW: 1244,
    OE: 900,
    EY: 864,
    XE: 819,
    AE: 816,
    YE: 777,
    EH: 577,
    EQ: 555,
    JE: 453,
    EK: 301,
  },
  F: {
    FI: 4353,
    FO: 3381,
    FF: 3262,
    FL: 3081,
    FE: 3029,
    FA: 2620,
    IF: 2364,
    FU: 2270,
    FR: 2070,
    EF: 1845,
    NF: 1244,
    AF: 901,
    OF: 886,
    FT: 685,
    RF: 684,
    UF: 506,
    LF: 453,
    FY: 428,
    TF: 403,
    FS: 288,
    SF: 243,
  },
  G: {
    NG: 18777,
    GE: 6042,
    OG: 4152,
    GI: 4024,
    GA: 3849,
    AG: 3578,
    IG: 3363,
    GR: 3290,
    GL: 2742,
    GG: 2552,
    GO: 2092,
    EG: 1906,
    GS: 1751,
    GH: 1643,
    GU: 1573,
    RG: 1540,
    UG: 1188,
    GN: 1109,
    GY: 637,
    DG: 617,
    GM: 345,
    LG: 282,
    YG: 238,
  },
  H: {
    HE: 7868,
    CH: 6859,
    TH: 5640,
    SH: 5533,
    HO: 5332,
    HI: 5169,
    HA: 4913,
    PH: 4210,
    HY: 1919,
    GH: 1643,
    HT: 1205,
    HR: 1179,
    HU: 1100,
    HS: 755,
    WH: 700,
    EH: 577,
    HL: 577,
    RH: 562,
    HN: 474,
    NH: 455,
    AH: 453,
    HM: 356,
    OH: 219,
  },
  I: {
    IN: 32499,
    TI: 21415,
    IS: 15386,
    RI: 14393,
    LI: 14112,
    IC: 11478,
    IT: 10191,
    IE: 9723,
    DI: 9448,
    IO: 8936,
    NI: 7728,
    MI: 7381,
    SI: 7264,
    IL: 7085,
    IA: 5664,
    HI: 5169,
    CI: 4851,
    ID: 4615,
    PI: 4577,
    IZ: 4381,
    FI: 4353,
    GI: 4024,
    IM: 3649,
    IV: 3549,
    IG: 3363,
    BI: 3349,
    IR: 3279,
    AI: 3209,
    VI: 3171,
    KI: 2456,
    IP: 2446,
    IF: 2364,
    OI: 2125,
    UI: 1841,
    IB: 1800,
    EI: 1707,
    WI: 1656,
    ZI: 1329,
    XI: 897,
    YI: 750,
    IK: 736,
    IU: 680,
    IX: 331,
    IQ: 210,
  },
  J: {
    JU: 546,
    JO: 546,
    JA: 537,
    JE: 453,
    NJ: 202,
  },
  K: {
    CK: 3952,
    KE: 3747,
    KI: 2456,
    KS: 1673,
    NK: 1297,
    AK: 1277,
    RK: 1118,
    SK: 909,
    OK: 873,
    KA: 743,
    IK: 736,
    KL: 577,
    LK: 498,
    KN: 378,
    KO: 357,
    KY: 310,
    EK: 301,
  },
  L: {
    LL: 15584,
    LE: 14713,
    LI: 14112,
    AL: 13873,
    LA: 10282,
    EL: 8044,
    LO: 7807,
    OL: 7387,
    IL: 7085,
    LY: 6602,
    UL: 5379,
    BL: 4607,
    PL: 3340,
    LU: 3113,
    FL: 3081,
    GL: 2742,
    LS: 2696,
    CL: 2269,
    LT: 1717,
    SL: 1673,
    TL: 1569,
    DL: 1299,
    LD: 1169,
    RL: 1161,
    YL: 872,
    NL: 604,
    HL: 577,
    KL: 577,
    LM: 543,
    LK: 498,
    LF: 453,
    LN: 434,
    LC: 433,
    LV: 414,
    LP: 368,
    LB: 287,
    LG: 282,
    WL: 268,
  },
  M: {
    ME: 8158,
    MI: 7381,
    MA: 6973,
    EM: 5560,
    OM: 5560,
    MO: 4623,
    AM: 4620,
    IM: 3649,
    UM: 3467,
    MP: 3138,
    MM: 3126,
    RM: 2768,
    SM: 2706,
    MB: 2246,
    MS: 2238,
    MU: 1660,
    YM: 858,
    MY: 693,
    LM: 543,
    NM: 425,
    HM: 356,
    GM: 345,
    TM: 334,
    MN: 270,
    DM: 210,
  },
  N: {
    IN: 32499,
    NG: 18777,
    ON: 17368,
    EN: 16909,
    AN: 13554,
    NE: 13210,
    NT: 11411,
    NS: 8832,
    NI: 7728,
    UN: 7212,
    NA: 6367,
    ND: 6332,
    NC: 5521,
    NO: 5173,
    NN: 3162,
    RN: 1804,
    NU: 1384,
    NK: 1297,
    NF: 1244,
    SN: 1116,
    GN: 1109,
    NV: 695,
    WN: 683,
    YN: 638,
    NL: 604,
    NY: 562,
    HN: 474,
    NR: 469,
    DN: 460,
    NB: 457,
    NH: 455,
    LN: 434,
    NM: 425,
    NP: 394,
    KN: 378,
    TN: 352,
    NW: 318,
    MN: 270,
    NJ: 202,
  },
  O: {
    ON: 17368,
    OR: 12462,
    RO: 10632,
    IO: 8936,
    CO: 8470,
    LO: 7807,
    TO: 7656,
    OO: 7648,
    OL: 7387,
    OU: 7269,
    OS: 5761,
    OM: 5560,
    HO: 5332,
    NO: 5173,
    OT: 4933,
    PO: 4919,
    MO: 4623,
    OP: 4462,
    OG: 4152,
    DO: 3749,
    OC: 3593,
    SO: 3539,
    FO: 3381,
    BO: 3344,
    OD: 2744,
    OV: 2673,
    OW: 2604,
    OI: 2125,
    GO: 2092,
    OB: 1793,
    EO: 1706,
    OA: 1615,
    WO: 1566,
    VO: 1170,
    OE: 900,
    OF: 886,
    OK: 873,
    OX: 780,
    JO: 546,
    ZO: 521,
    YO: 482,
    OY: 481,
    UO: 443,
    KO: 357,
    XO: 357,
    OZ: 309,
    OH: 219,
  },
  P: {
    PE: 7177,
    PR: 5514,
    PO: 4919,
    PA: 4717,
    PI: 4577,
    OP: 4462,
    PH: 4210,
    EP: 3910,
    AP: 3856,
    PP: 3672,
    SP: 3504,
    PL: 3340,
    MP: 3138,
    IP: 2446,
    UP: 2199,
    PS: 1869,
    PT: 1553,
    PU: 1534,
    RP: 1310,
    YP: 1065,
    XP: 822,
    PY: 540,
    NP: 394,
    LP: 368,
    TP: 225,
  },
  Q: {
    QU: 2433,
    EQ: 555,
    SQ: 391,
    IQ: 210,
  },
  R: {
    ER: 30628,
    RE: 19205,
    RI: 14393,
    RA: 13999,
    OR: 12462,
    AR: 12030,
    RO: 10632,
    RS: 9455,
    TR: 7743,
    UR: 5959,
    PR: 5514,
    RR: 4660,
    RT: 3658,
    GR: 3290,
    IR: 3279,
    CR: 3184,
    RM: 2768,
    RU: 2716,
    RD: 2425,
    BR: 2392,
    RY: 2309,
    DR: 2266,
    FR: 2070,
    RC: 1993,
    RN: 1804,
    RG: 1540,
    RB: 1349,
    RP: 1310,
    HR: 1179,
    RL: 1161,
    RK: 1118,
    RF: 684,
    RV: 674,
    RH: 562,
    YR: 557,
    NR: 469,
    WR: 416,
    RW: 376,
  },
  S: {
    ES: 35462,
    SS: 18944,
    ST: 15673,
    IS: 15386,
    SE: 11672,
    RS: 9455,
    NS: 8832,
    AS: 8029,
    SI: 7264,
    TS: 6361,
    US: 5991,
    OS: 5761,
    SH: 5533,
    SC: 4042,
    SU: 3867,
    SO: 3539,
    SA: 3517,
    SP: 3504,
    DS: 2825,
    SM: 2706,
    LS: 2696,
    MS: 2238,
    PS: 1869,
    GS: 1751,
    KS: 1673,
    SL: 1673,
    YS: 1407,
    SN: 1116,
    SY: 1053,
    SK: 909,
    CS: 779,
    HS: 755,
    BS: 754,
    SW: 689,
    WS: 585,
    SQ: 391,
    SB: 322,
    FS: 288,
    SF: 243,
  },
  T: {
    TI: 21415,
    TE: 19548,
    AT: 18317,
    ST: 15673,
    NT: 11411,
    IT: 10191,
    TA: 8059,
    ET: 7760,
    TR: 7743,
    TO: 7656,
    TS: 6361,
    TT: 6132,
    TH: 5640,
    OT: 4933,
    UT: 4467,
    CT: 4426,
    RT: 3658,
    TU: 2989,
    TY: 2394,
    LT: 1717,
    TL: 1569,
    PT: 1553,
    HT: 1205,
    TC: 1065,
    XT: 779,
    YT: 731,
    FT: 685,
    TW: 537,
    TF: 403,
    TB: 372,
    TN: 352,
    TM: 334,
    TP: 225,
    TZ: 223,
  },
  U: {
    OU: 7269,
    UN: 7212,
    US: 5991,
    UR: 5959,
    UL: 5379,
    UT: 4467,
    SU: 3867,
    UM: 3467,
    LU: 3113,
    TU: 2989,
    CU: 2977,
    RU: 2716,
    QU: 2433,
    FU: 2270,
    UP: 2199,
    UC: 2078,
    BU: 1979,
    UB: 1969,
    AU: 1852,
    UI: 1841,
    UA: 1818,
    DU: 1808,
    MU: 1660,
    UE: 1581,
    GU: 1573,
    PU: 1534,
    EU: 1394,
    NU: 1384,
    UD: 1374,
    UG: 1188,
    HU: 1100,
    IU: 680,
    JU: 546,
    UF: 506,
    UO: 443,
  },
  V: {
    VE: 7483,
    IV: 3549,
    VI: 3171,
    OV: 2673,
    VA: 2286,
    EV: 1901,
    AV: 1554,
    VO: 1170,
    NV: 695,
    RV: 674,
    LV: 414,
  },
  W: {
    OW: 2604,
    WA: 2340,
    WE: 1837,
    WI: 1656,
    WO: 1566,
    EW: 1244,
    AW: 924,
    WH: 700,
    SW: 689,
    WN: 683,
    WS: 585,
    TW: 537,
    WR: 416,
    RW: 376,
    NW: 318,
    DW: 274,
    WL: 268,
  },
  X: {
    EX: 3551,
    XI: 897,
    XP: 822,
    XE: 819,
    OX: 780,
    XT: 779,
    AX: 458,
    XC: 446,
    XA: 399,
    XO: 357,
    IX: 331,
  },
  Y: {
    LY: 6602,
    TY: 2394,
    RY: 2309,
    HY: 1919,
    YS: 1407,
    AY: 1330,
    YP: 1065,
    SY: 1053,
    CY: 904,
    YL: 872,
    EY: 864,
    YM: 858,
    YE: 777,
    YI: 750,
    YT: 731,
    YC: 723,
    MY: 693,
    YN: 638,
    GY: 637,
    DY: 576,
    NY: 562,
    YR: 557,
    YA: 544,
    PY: 540,
    YO: 482,
    OY: 481,
    FY: 428,
    YD: 403,
    KY: 310,
    YB: 240,
    YG: 238,
    BY: 213,
  },
  Z: {
    IZ: 4381,
    ZE: 3486,
    ZI: 1329,
    ZA: 864,
    ZZ: 788,
    AZ: 632,
    ZO: 521,
    OZ: 309,
    TZ: 223,
  },
}